import { useEffect, useState } from 'react';
import './CircularTimer.css';

export default function CircularTimer({ duration = 300 }) {
  const [timeLeft, setTimeLeft] = useState(duration);

  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => setTimeLeft(t => t - 1), 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);

  const backgroundRadius = 40;
  const progressRadius = 50;
  const circumference = 2 * Math.PI * progressRadius;
  const progress = (timeLeft / duration) * circumference;

  const minutes = Math.floor(timeLeft / 60)
    .toString()
    .padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');

  return (
    <div className="circular-timer">
      <svg className="timer-svg" viewBox="0 0 120 120">
        {/* Círculo de fundo menor */}
        <circle
          cx="60"
          cy="60"
          r={backgroundRadius}
          fill="#2a707c"
        />
        {/* Arco de fundo turquesa (sempre completo) */}
        <circle
          cx="60"
          cy="60"
          r={progressRadius}
          stroke="#2a707c"
          strokeWidth="8"
          fill="none"
        />
        {/* Arco de progresso amarelo (vai diminuindo) */}
        <circle
          cx="60"
          cy="60"
          r={progressRadius}
          stroke="#f5b301"
          strokeWidth="8"
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          strokeLinecap="round"
          className="timer-progress"
        />
      </svg>
      <div className="timer-text">
        {minutes}:{seconds}
      </div>
    </div>
  );
}

